<template>
    <full-page-carousel
        :images="images"
        :mobileImages="mobileImages"
    >
        <v-layout>
            <v-flex
                xs10
                md4
                lg4
                xl4
                offset-xs1
                offset-md7
                offset-lg7
                offset-xl7
                class="auth"
            >
                <div
                    class="auth__title"
                >
                    {{ title }}
                </div>
                <div class="auth__description">
                    {{ description }}
                </div>
                <slot/>
          </v-flex>
        </v-layout>
  </full-page-carousel>
</template>

<script>
import FullPageCarousel from '@/components/auth/FullPageCarousel';

export default {
  name: 'auth-container',
  components: {
    FullPageCarousel
  },
  props: {
    title: String,
    description: String,
    images: {
      type: Array,
      required: true
    },
    mobileImages: {
      type: Array,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../assets/scss/breakpoint';

.auth {
  position: relative;
  margin-top: 5%;
  margin-bottom: 5%;

  &__title {
    font-size: 1.5em;
    font-weight: var(--font-weight);
    margin: 10px 0;
    color: var(--login-title-color);

    @include breakpoint(mobile) {
      top: 5%;
      left: 5%;
      width: 90%;
      text-align: center;
      font-size: 1.25em;
    }
  }

  &__description {
    width: 100%;
    color: var(--login-subtitle-color);
    font-size: 1em;
    margin: 10px 0 35px 0;

    @include breakpoint(mobile) {
      color: var(--login-subtitle-color);
      top: 10%;
      margin: 5px 0;
      text-align: center;
      font-size: 1em;
    }
  }
}
</style>



// WEBPACK FOOTER //
// ./src/components/auth/Container.vue